import { onAuthStateChanged } from "firebase/auth";
import {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState
} from "react";

import { getFirebaseAuth } from "services/firebase/auth";

type AuthContextType = {
  provider?: string | null;
};

const AuthContext = createContext<AuthContextType>({ provider: null });

export default function AuthProvider({ children }: { children: ReactNode }) {
  const [provider, setProvider] = useState<string | null>(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(getFirebaseAuth(), async user => {
      if (user) {
        const token = await user.getIdTokenResult();
        setProvider(token.signInProvider);
      } else {
        setProvider(null);
      }
    });

    return () => unsubscribe();
  }, []);

  return (
    <AuthContext.Provider value={{ provider }}>{children}</AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
}
